module.exports = __webpack_public_path__ + "8491647547b14af13466d6ef79e4c620.png";